import { GetServiceProviderBySlugWithDiscountRulesAndPreferences } from 'Common/functions/getServiceProviderBySlugWithDiscountRulesAndPreferences';
import dayjs from 'dayjs';
import { useMemo } from 'react';

type ServiceProviderAvailabilityTableProps = {
  dayOfWeekAvailability: NonNullable<GetServiceProviderBySlugWithDiscountRulesAndPreferences>['dayOfWeekAvailability'];
}

const dayOfWeekNameMap = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const startOfDay = dayjs().startOf('d');

const ServiceProviderAvailabilityTable: React.FC<ServiceProviderAvailabilityTableProps> = ({
  dayOfWeekAvailability: avail,
}) => {
  const sortedAvail = useMemo(
    () => [...avail].sort((a, b) => a.dayOfWeek - b.dayOfWeek),
    [avail],
  );

  return (
    <section
      className="flex flex-col sm:w-full gap-4"
    >
      <span className="text-lg font-bold">
        Availability
      </span>
      <div>
        {sortedAvail.map(a => (
          <div
            key={a.dayOfWeek}
            className="flex justify-between mb-2 gap-x-4"
          >
            <span>
              {dayOfWeekNameMap[a.dayOfWeek]}:
            </span>
            <span>
              {a.availability.timeUtcSecondsBounds.length > 0 ?
                a.availability.timeUtcSecondsBounds.map(
                  (b, i) => {
                    if (b.min !== null &&
                      b.min !== undefined &&
                      b.min !== null &&
                      b.min !== undefined &&
                      b.max !== null &&
                      b.max !== undefined) {
                      const start = startOfDay
                        .clone()
                        .add(b.min, 's')
                        .format('h:mm a');
                      const end = startOfDay
                        .clone().add(b.max, 's')
                        .format('h:mm a');

                      return (
                        <span key={i}>
                          {`${start} - ${end}`}
                        </span>
                      );
                    }
                  }
                ) :
                'Unavailable'}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceProviderAvailabilityTable;
